// Open Upsell listener
document.querySelectorAll(".openUpsell").forEach(function (element) {
    element.addEventListener("click", () => {
        openUpsell();
    });
});

// Opens upsell dialog
function openUpsell() {
    document.querySelector("#upsell").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// Closes upsell dialog
document.querySelectorAll(".closeUpsell").forEach(function (element) {
    element.addEventListener("click", () => {
        document.querySelector('#upsell').close();
        openCart();
    });
});

// clicking backdrop closes
document.querySelector("#upsell").addEventListener('click', function (event) {
    if (event.target === this) {
        document.querySelector('#upsell').close();
        openCart();
    }
});

// when close event is triggered on modal
document.querySelector("#upsell").addEventListener('close', function (event) {
    document.querySelector("body").classList.remove("noScroll");
});

// Register dialog for backward compatibility
dialogPolyfill.registerDialog(document.querySelector('#upsell'));